export default __webpack_public_path__ + "static/SuisseIntl-Regular-a2a868e77b7a7d726af66cca6b3291aa.woff2";